import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Location } from "@angular/common";

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss']
})
export class MobileHeaderComponent {
  @Input() isShowBackButton: boolean = true;
  @Input() title: string;
  @Input() manualBackEvent: boolean = false;
  @Input() dialogHeader: boolean = false;
  @Output() onManualBackEvent = new EventEmitter();

  constructor(
    private location: Location
  ) { }

  ngOnInit(): void {
  }

  backWithLocation() {
    if (this.manualBackEvent) {
      this.onManualBackEvent.emit();
    } else {
      this.location.back();
    }
  }
}
